import { type RootState } from "~/app/store";

export const selectProductComparisonList = (state: RootState) => state.productComparison.comparisonList;
